<template>
  <div class="modal-backdrop">
    <div class="modal" v-click-outside="close">
      <header :class="['modal-header', { 'warning-popup': isWarningPopup }]">
        <slot name="header" />
        <button class="btn-close" @click="close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="#fff"
            stroke="#fff"
            stroke-width="3.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </header>
      <section class="modal-body">
        <slot name="body" />
      </section>
      <footer class="modal-footer">
        <slot name="footer" />
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    isWarningPopup: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
  },
};
</script>

<style scoped>
@import "index.module.css";
</style>
